import React from 'react';
import MessageContent from 'components/messages/MessageContent';
import Message from 'components/Message';

const TooManyAttempts = ({
  onDismiss,
}) => (
  <Message
    type="error"
    onDismiss={onDismiss}
    message={(
      <MessageContent>
        Sorry, there have been too many failed attempts to log in. Please try
        again later.
      </MessageContent>
    )}
  />
);

TooManyAttempts.displayName = 'TooManyAttempts';

TooManyAttempts.propTypes = {
  onDismiss: Message.propTypes.onDismiss.isRequired,
};

export default TooManyAttempts;
